import moment from 'moment';

export const formatDate = (date: string): string => moment(date).format('DD/MM/YYYY');
export const rowsPerPageOptions = [5, 10, 25];
export const defaultRowsPerPage = 5;
